export default (text: string | undefined): { __html: string } | undefined => {
    let result = undefined;

    if (text) {
        const bodyText = text
            .replace(new RegExp("http://localhost:3000", "g"), "")
            .replace(new RegExp("https://stage.easyfood.frontend.heyday.dk", "g"), "")
            .replace(new RegExp("http://easyfood.heyday.dk", "g"), "")
            .replace(new RegExp("https://easyfood.dk", "g"), "");

        result = {
            __html: bodyText,
        };
    }

    return result;
};
